import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

declare var $: any;

@Component({
    selector: "ai-suggestions-popup",
    templateUrl: "./ai-suggestions-popup.component.html",
    styleUrls: ["./ai-suggestions-popup.component.scss"],
    standalone: false
})
export class AiSuggestionsPopupComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<AiSuggestionsPopupComponent>>(MatDialogRef);

    suggestions: string[];
    currentSuggestion: string;
    currentSuggestionIndex: number;

    ngOnInit(): void {
        this.suggestions = this.data.suggestions;
        this.currentSuggestionIndex = 1;
        this.currentSuggestion = this.suggestions[0];
    }

    selectSuggestion(index) {
        this.currentSuggestionIndex = index;
        this.currentSuggestion = this.suggestions[this.currentSuggestionIndex - 1];
    }

    onApplyChanges() {
        this.data.onConfirm(this.currentSuggestion);
        this.dialogRef.close();
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
